import moment from 'moment';

/**
 * Returns the current date, or a mocked date in local development if configured.
 *
 * This is useful for local development when working with seeded data that has
 * specific dates. Set REACT_APP_MOCK_CURRENT_DATE in .env.local to override
 * the current date.
 *
 * @returns Date object representing either the current date or the mocked date
 */
export const getCurrentDate = (): Date => {
  const mockDate = process.env.REACT_APP_MOCK_CURRENT_DATE;

  if (mockDate && process.env.NODE_ENV === 'development') {
    return new Date(mockDate);
  }

  return new Date();
};

/**
 * Returns the current moment, or a mocked moment in local development if configured.
 *
 * This is useful for local development when working with seeded data that has
 * specific dates. Set REACT_APP_MOCK_CURRENT_DATE in .env.local to override
 * the current date.
 *
 * @returns Moment object representing either the current date or the mocked date
 */
export const getCurrentMoment = () => {
  const mockDate = process.env.REACT_APP_MOCK_CURRENT_DATE;

  if (mockDate && process.env.NODE_ENV === 'development') {
    return moment(mockDate);
  }

  return moment();
};
